// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3ovf-","productName":"Table_productName__QcWng"};